import { CreateUserDto, UserDto, UsersApi } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';

type UseCreateUser = (
  usersApi: UsersApi,
  options?: Omit<
    UseMutationOptions<AxiosResponse<UserDto>, ErrorResponse, CreateUserDto>,
    'mutationFn'
    >,
) => UseMutationResult<AxiosResponse<UserDto>, ErrorResponse, CreateUserDto>;

export const useCreateUser: UseCreateUser = (
  usersApi,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    (createUserDto: CreateUserDto) => usersApi.createUser(tenantId, createUserDto),
    options,
  );
};
